import axios from "axios";
import { ls_vars } from "Library/Constants";

const timeout = process.env.NODE_ENV === "development" ? 300000 : 120000;
const api = axios.create({
  timeout,
  // X-Client-App identifies the admin portal to the shared SSO backend so that the
  // organization-role grant is honored only for requests originating here.
  headers: { "Content-Type": "application/json", "X-Client-App": "admin" },
  withCredentials: true,
  responseType: "json",
});

const tokenHeaders = () => {
  const accessToken = getLocalStorage(ls_vars.ACCESS_TOKEN);
  const headers = accessToken
    ? { headers: { Authorization: `JWT ${accessToken}` } }
    : {};
  return headers;
};

export const setLocalStorage = (tokenName: string, data: any) => {
  localStorage.setItem(tokenName, JSON.stringify(data));
};

export const getLocalStorage = (tokenName: string) => {
  const item = localStorage.getItem(tokenName);
  try {
    return item ? JSON.parse(item) : null;
  } catch (error) {
    return localStorage.getItem(tokenName);
  }
};

export const get = async <T>(url: string, params?: Record<string, any>) => {
  const queryParams = params || {};
  const region = getLocalStorage(ls_vars.REGION_ID);
  const platformCode = getLocalStorage(ls_vars.PLATFORM)?.code;
  if (region) queryParams.region = region;
  if (platformCode) queryParams.platform = platformCode;
  const headers = tokenHeaders();
  const response = await api.get<T>(url, {
    ...headers,
    params: queryParams,
  });
  return response;
};

export const post = async (
  url: string,
  data: any,
  params?: Record<string, any>
) => {
  const queryParams = params || {};
  const region = getLocalStorage(ls_vars.REGION_ID);
  if (region) queryParams.region = region;
  const headers = tokenHeaders();
  const response = await api.post(url, data, {
    ...headers,
    params: queryParams,
  });
  return response;
};

export const put = async (
  url: string,
  data: any,
  params?: Record<string, any>
) => {
  const queryParams = params || {};
  const region = getLocalStorage(ls_vars.REGION_ID);
  if (region) queryParams.region = region;
  const headers = tokenHeaders();
  const response = await api.put(url, data, {
    ...headers,
    params: queryParams,
  });
  return response;
};

export const patch = async (
  url: string,
  data: any,
  params?: Record<string, any>
) => {
  const queryParams = params || {};
  const region = getLocalStorage(ls_vars.REGION_ID);
  if (region) queryParams.region = region;
  const headers = tokenHeaders();
  const response = await api.patch(url, data, {
    ...headers,
    params: queryParams,
  });
  return response;
};

// Note: delete is a reserved word
export const remove = async (url: string, params?: Record<string, any>) => {
  const queryParams = params || {};
  const region = getLocalStorage(ls_vars.REGION_ID);
  if (region) queryParams.region = region;
  const headers = tokenHeaders();
  const response = await api.delete(url, {
    ...headers,
    params: queryParams,
  });
  return response;
};
